import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=0b06f61a&scoped=true&lang=pug"
import script from "./NotificationTable.vue?vue&type=script&lang=ts"
export * from "./NotificationTable.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=0b06f61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06f61a",
  null
  
)

export default component.exports